export default __webpack_public_path__ + "static/media/39_mobile.b639a87e.jpg";